import { render, staticRenderFns } from "./ApuracaoAcaoLista.vue?vue&type=template&id=6b3fc0b0&scoped=true"
import script from "./ApuracaoAcaoLista.vue?vue&type=script&lang=js"
export * from "./ApuracaoAcaoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3fc0b0",
  null
  
)

export default component.exports